<template>
  <div :class="['ecx-spinner flex justify-center items-center', containerClass]">
    <div
      :class="[
        'animate-spin rounded-full border-solid',
        sizeClasses,
        variantClasses,
      ]"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
export type SpinnerVariant = 'primary' | 'secondary' | 'white' | 'dark'

export interface SpinnerProps {
  /** Tamanho do spinner */
  size?: SpinnerSize
  /** Variante de cor */
  variant?: SpinnerVariant
  /** Classes adicionais para o container */
  containerClass?: string
}

const props = withDefaults(defineProps<SpinnerProps>(), {
  size: 'md',
  variant: 'primary',
})

const sizeClasses = computed(() => {
  const sizes: Record<SpinnerSize, string> = {
    xs: 'h-4 w-4 border-2',
    sm: 'h-6 w-6 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
    xl: 'h-16 w-16 border-4',
  }
  return sizes[props.size]
})

const variantClasses = computed(() => {
  const variants: Record<SpinnerVariant, string> = {
    primary: 'border-primary border-t-transparent',
    secondary: 'border-grey-300 border-t-transparent',
    white: 'border-white border-t-transparent',
    dark: 'border-grey-800 border-t-transparent',
  }
  return variants[props.variant]
})
</script>

